import { Alert, styled } from "@mui/material";

const CustomAlertWithButton = styled(Alert)`
  & .MuiAlert-message {
    flex: 1;
  }
`;

export default CustomAlertWithButton;
